import {
  jb_info_page_hero_css_default
} from "./chunk.TRF3CCNM.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-info-page-hero/jb-info-page-hero.ts
var JbInfoPageHero = class extends Spaceable(i) {
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 8, horizontal: "full-width-sm-down", type: "no-vertical-space" };
  }
  render() {
    return b`
      <jb-heading
        rank="1"
        variant="title-overview"
        >${this.header}</jb-heading
      >
      ${this.subheader ? b`<jb-heading rank="2">${this.subheader}</jb-heading>` : A}
      ${this.image ? b`<jb-picture
              .imgData=${this.image.imgData}
              alt=${this.image.alt}
              fit="cover"
              aspect="aspect_21by9"
            ></jb-picture>` : A}
      <slot></slot>
    `;
  }
};
JbInfoPageHero.styles = [reset_css_default, jb_info_page_hero_css_default];
__decorateClass([
  n()
], JbInfoPageHero.prototype, "header", 2);
__decorateClass([
  n({ type: Object })
], JbInfoPageHero.prototype, "image", 2);
__decorateClass([
  n()
], JbInfoPageHero.prototype, "subheader", 2);
JbInfoPageHero = __decorateClass([
  customElement("jb-info-page-hero")
], JbInfoPageHero);

export {
  JbInfoPageHero
};
